export const removeLocation = (locationId) => ({
  type: 'REMOVE_LOCATION',
  payload: {
    locationId
  }
})

export const selectLocation = (locationId, kind) => ({
  type: 'SELECT_LOCATION',
  payload: {
    locationId,
    kind
  }
})

export const addLocation = (position) => ({
  type: 'ADD_LOCATION',
  payload: {
    position
  }
})

export const changePopupLocation = (kind) => ({
  type: 'CHANGE_POPUP_LOCATION',
  payload: {
    kind
  }
})

export const changePopupData = (data) => ({
  type: 'CHANGE_POPUP_DATA',
  payload: {
    data
  }
})

export const openPopup = (locationId) => ({
  type: 'OPEN_POPUP',
  payload: {
    locationId
  }
})

export const dismissPopup = () => ({
  type: 'DISMISS_POPUP'
})

export const confirmPopup = () => ({
  type: 'CONFIRM_POPUP'
})

export const clearPotentialKind = () => ({
  type: 'CLEAR_POTENTIAL_KIND'
})

export const updateIntegrations = (integrations) => ({
  type: 'UPDATE_INTEGRATIONS',
  payload: {
    integrations
  }
})

export const selectLocationConfiguration = (locationId, locationConfiguration) => ({
  type: 'SELECT_LOCATION_CONFIGURATION',
  payload: {
    locationId,
    locationConfiguration
  }
})

export const updateLocations = (locations) => ({
  type: 'UPDATE_LOCATIONS',
  payload: {
    locations
  }
})
